import { render, staticRenderFns } from "./TerminosLegales.vue?vue&type=template&id=53429762&scoped=true"
import script from "./TerminosLegales.vue?vue&type=script&lang=js"
export * from "./TerminosLegales.vue?vue&type=script&lang=js"
import style0 from "./TerminosLegales.vue?vue&type=style&index=0&id=53429762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53429762",
  null
  
)

export default component.exports